module.exports = __webpack_public_path__ + "img/FR13485.7d33360a.png";